import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-[#0c1427] p-5 rounded-md shadow-md flex flex-col min-h-[450px] custom-fields-panel" }
const _hoisted_2 = { class: "text-black dark:text-white font-semibold mb-6 text-center text-xl" }
const _hoisted_3 = { class: "mb-5 flex-grow" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center items-center h-40"
}
const _hoisted_5 = {
  key: 1,
  class: "text-gray-500 italic"
}
const _hoisted_6 = {
  key: 2,
  class: "space-y-2 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar"
}
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "text-black dark:text-white font-medium" }
const _hoisted_9 = { class: "text-xs text-gray-500" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex justify-between flex-nowrap gap-2 w-full mt-auto" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.management')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-500" }, null, -1)
          ])))
        : (_ctx.customFields.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.noFields')), 1))
          : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFields, (field, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "flex items-center justify-between bg-white dark:bg-[#0c1427] p-3 rounded border border-gray-200 dark:border-[#1c2b50]"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(field.label), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getFieldTypeName(field.type)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.editField(index)),
                      class: "text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                    }, _cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, "edit", -1)
                    ]), 8, _hoisted_11),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.deleteField(index)),
                      class: "text-red-500 hover:text-red-700"
                    }, _cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, "delete", -1)
                    ]), 8, _hoisted_12)
                  ])
                ]))
              }), 128))
            ]))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewField && _ctx.addNewField(...args))),
        class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md flex items-center whitespace-nowrap"
      }, [
        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "material-symbols-outlined mr-1" }, "add_circle", -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.addField')), 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveCustomFields && _ctx.saveCustomFields(...args))),
        class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md whitespace-nowrap",
        disabled: _ctx.saving
      }, _toDisplayString(_ctx.saving ? _ctx.directT('settings.leadsSettings.saving') : _ctx.directT('settings.leadsSettings.saveChanges')), 9, _hoisted_14)
    ])
  ]))
}